import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { DataGrid } from "@mui/x-data-grid";
import { AWS_URL } from "../../Constant";
import { v4 as uuidv4 } from "uuid";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const columns = [
  {
    field: "RetailStoreCode",
    headerName: "Store Name",
    width: 120,
    headerClassName: "custom-header",
    headerAlign: "center",
  },
  {
    field: "EmpId",
    headerName: "EmpId",
    width: 150,
    headerClassName: "custom-header",
    headerAlign: "center",
  },
  {
    field: "customerName",
    headerName: "customer Name",
    width: 170,
    headerClassName: "custom-header",
    headerAlign: "center",
  },
  {
    field: "customerNumber",
    headerName: "Customer Number",
    width: 160,
    headerClassName: "custom-header",
    headerAlign: "center",
  },
  {
    field: "productName",
    headerName: "Product Name",
    type: "number",
    width: 220,
    headerClassName: "custom-header",
    headerAlign: "center",
  },
  {
    field: "brand",
    headerName: "Brand",
    width: 120,
    headerClassName: "custom-header",
    headerAlign: "center",
  },
  {
    field: "barcode",
    headerName: "Barcode",
    width: 110,
    headerClassName: "custom-header",
    headerAlign: "center",
  },
  {
    field: "model_number",
    headerName: "Model number",
    width: 170,
    headerClassName: "custom-header",
    headerAlign: "center",
  },

  {
    field: "quantity",
    headerName: "Quantity",
    type: "number",
    width: 100,
    headerClassName: "custom-header",
    headerAlign: "center",
  },
  {
    field: "gst",
    headerName: "GST",
    type: "number",
    width: 100,
    headerClassName: "custom-header",
    headerAlign: "center",
  },
  {
    field: "subtotal",
    headerName: "Sub Total",
    type: "number",
    width: 150,
    headerClassName: "custom-header",
    headerAlign: "center",
  },
];

const Sales = () => {
  const [salesData, setSalesData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [filterProduct, setFilterProductList] = useState([]);const flattenData = (products) => {
    return products.reduce((acc, item) => {
      item.datas.forEach((stock) => {
        acc.push({
          customerName: item.customerName,
          customerAddress: item.customerAddress,
          customerNumber: item.customerNumber,
          EmpId: item.EmpId,
          date: item.date,
          paymentMode: item.paymentMode,
          transactionId: item.transactionId,
          BillNo: item.BillNo,
          totalAmtWithoutGst: item.totalAmtWithoutGst,
          gst: item.gst,
          subtotal: item.subtotal,
          barcode: stock.barcode,
          brand: stock.brand,
          model_number: stock.model_number,
          productName: stock.productName,
          serialNumber: stock.serialNumber,
          quantity: stock.quantity,
          mrp1: stock.mrp1,
          landingCost: stock.landingCost,
          discount: stock.discount,
          cutoffprice: stock.cutoffprice,
          RetailStoreCode: item.RetailStoreCode || "Unknown",
          _id: stock._id || uuidv4(),
        });
      });
      return acc;
    }, []);
  };

  const fetchData = async () => {
    const jwtToken = Cookies.get("jwt_token");
    const url = `${AWS_URL}/getStoreData`;

    const option = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
    };
    try {
      const response = await fetch(url, option);
      if (response.status === 200) {
        const data = await response.json();
        setSalesData(data["Sales"]);
      }
    } catch (error) {}
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleFilterData = (event) => {
    setSearchQuery(event.target.value);
  };

  useEffect(() => {
    const allSalesStocks = flattenData(salesData);const regex = new RegExp(searchQuery, "i");
    const isWithinDateRange = (value) => {
      if (!fromDate && !toDate) {
        return true;
      }

      const rowDate = value ? new Date(value) : null;
      if (!rowDate || Number.isNaN(rowDate.getTime())) {
        return false;
      }

      if (fromDate) {
        const from = new Date(fromDate);
        from.setHours(0, 0, 0, 0);
        if (rowDate < from) {
          return false;
        }
      }

      if (toDate) {
        const to = new Date(toDate);
        to.setHours(23, 59, 59, 999);
        if (rowDate > to) {
          return false;
        }
      }

      return true;
    };

    const filteredData = allSalesStocks.filter((product) => {
      const matchesSearch =
        regex.test(product.productName) ||
        regex.test(product.brand) ||
        regex.test(product.RetailStoreCode) ||
        regex.test(product.model_number) ||
        regex.test(product.EmpId);

      return matchesSearch && isWithinDateRange(product.date);
    });

    setFilterProductList(filteredData);
  }, [salesData, searchQuery, fromDate, toDate]);

  const getExportRows = () => {
    return filterProduct.map((item) => ({
      StoreName: item.RetailStoreCode,
      EmpId: item.EmpId,
      customerNames: item.customerName,
      customerNumber: item.customerNumber,
      productName: item.productName,
      brand: item.brand,
      barcode: item.barcode,
      Model_number: item.model_number,
      quantity: item.quantity,
      gst: item.gst,
      subtotal: item.subtotal,
    }));
  };

  const downloadExcel = () => {
    const rows = getExportRows();
    if (!rows.length) {
      return;
    }
    const worksheet = XLSX.utils.json_to_sheet(rows);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sales");
    XLSX.writeFile(workbook, "sales-report.xlsx");
  };

  const downloadPdf = () => {
    const rows = getExportRows();
    if (!rows.length) {
      return;
    }
    const doc = new jsPDF("l", "mm", "a4");
    autoTable(doc, {
      head: [Object.keys(rows[0] || {})],
      body: rows.map((row) => Object.values(row)),
      styles: { fontSize: 8 },
      margin: { top: 15 },
    });
    doc.save("sales-report.pdf");
  };

  return (
    <>
      <div>
        <div className="m-2 flex justify-end ">
          <div className="gap-2 ">
            <Link to={"/dashboard"}>
              <button className=" mr-2 bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500  p-1 rounded-lg w-40 text-white text-lg  ">
                Dashboard
              </button>
            </Link>
          </div>
        </div>

        <div className="pl-5 pr-5 pb-2">
          <div className="rounded-xl border border-slate-200 bg-slate-50 p-3 shadow-sm">
            <div className="mb-3 flex flex-col gap-2 md:flex-row md:items-center md:justify-between">
              <h1 className="font-bold text-lg text-slate-800">Sales Reports</h1>
              {/* <p className="text-sm text-slate-600">Filter by date and export instantly</p> */}
            </div>

            <div className="flex flex-wrap items-end gap-3">
              <div className="flex flex-col">
                <label htmlFor="sales-search" className="mb-1 text-xs font-semibold text-slate-600">
                  Search
                </label>
                <input
                  type="search"
                  id="sales-search"
                  className="h-9 w-64 rounded-md border border-slate-300 bg-white px-2 text-sm placeholder:text-gray-500"
                  onChange={handleFilterData}
                  placeholder="Search products, brand, store"
                />
              </div>

              <div className="flex flex-col">
                <label className="mb-1 text-xs font-semibold text-slate-600">From</label>
                <input
                  type="date"
                  className="h-9 rounded-md border border-slate-300 bg-white px-2 text-sm"
                  value={fromDate}
                  onChange={(event) => setFromDate(event.target.value)}
                  title="From date"
                />
              </div>

              <div className="flex flex-col">
                <label className="mb-1 text-xs font-semibold text-slate-600">To</label>
                <input
                  type="date"
                  className="h-9 rounded-md border border-slate-300 bg-white px-2 text-sm"
                  value={toDate}
                  onChange={(event) => setToDate(event.target.value)}
                  title="To date"
                />
              </div>

              <div className="ml-auto flex gap-2">
                <button
                  className="h-9 rounded-md bg-green-600 px-3 text-sm font-semibold text-white"
                  onClick={downloadExcel}
                >
                  Download Excel
                </button>
                <button
                  className="h-9 rounded-md bg-red-600 px-3 text-sm font-semibold text-white"
                  onClick={downloadPdf}
                >
                  Download PDF
                </button>
              </div>
            </div>
          </div>
        </div>

        <div
          style={{ height: 500, width: "100%", overflow: "auto" }}
          className="p-4"
        >
          <DataGrid
            sx={{
              boxShadow: 2,
              border: 2,
              borderColor: "primary.light",
              "& .custom-header": {
                // fontSize: "h7.fontSize",
                fontWeight: "bold",
                fontSize: 16,
                color: "blue",
              },
              "& .MuiDataGrid-root, .MuiDataGrid-root ": {
                backgroundColor: "primary.main",
                color: "black",
              },
              "& .MuiDataGrid-colCell,  .MuiDataGrid-cell:hover": {
                color: "primary.main",
              },
              "& .MuiDataGrid-sortIcon ": {
                backgroundColor: "red",
              },
              ".MuiDataGrid-cell": {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              },
            }}
            rows={filterProduct}
            columns={columns}
            getRowId={(row) => row._id}
            initialState={{
              pagination: {
                paginationModel: { page: 0, pageSize: 20 },
              },
            }}
            pageSizeOptions={[5, 15]}
            checkboxSelection
            disableRowSelectionOnClick
          />
        </div>
      </div>
    </>
  );
};

export default Sales;
